module.exports = __webpack_public_path__ + "media/Blob 2 Joins.d40c2015.mp3";